export const TARGET_DATE = new Date('2025-06-15T00:00');

// export const BOOK_A_MEETING_LINK = 'https://calendar.app.google/uLzZnzJEhgucpFTS8';
export const BOOK_A_MEETING_LINK =
  'https://calendar.google.com/calendar/u/0/appointments/schedules/AcZssZ3HsUlQxGdKXwDGX9PvTnbZFP_LEu5Duwmy2bkVQXNxioqGYveXXLqx-wf_RhG0CC6gShPVrTga';

export const BOOK_A_DEMO_LINK = BOOK_A_MEETING_LINK;

export const BOOK_A_SENSORS_DEMO_LINK = BOOK_A_MEETING_LINK;

export const BOOK_A_RESEARCH_CALL_LINK = BOOK_A_MEETING_LINK;
